import { render, staticRenderFns } from "./VideoModalTutorial.vue?vue&type=template&id=b827cf22"
import script from "./VideoModalTutorial.vue?vue&type=script&lang=js"
export * from "./VideoModalTutorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports